// Utils
import { propIn } from '../../../../common/utils/immutableHelper';
import { getIsGuestProp, getRootBoardId, getUserId } from '../../../../common/users/utils/userPropertyUtils';

// Selectors
import { getCurrentBoardIdFromState } from '../../../reducers/currentBoardId/currentBoardIdSelector';
import { getClosestPermissionIdForElementIdSelector } from '../../../utils/permissions/permissionsSelector';
import { breadcrumbSelector } from '../../breadcrumbs/breadcrumbSelector';
import { getCurrentUser } from '../../../user/currentUserSelector';

// Actions
import { createAliasToElement } from '../../../element/actions/elementActions';
import { deselectAll } from '../../../../common/elements/selectionActions';

// Constants
import { BoardSections } from '../../../../common/boards/boardConstants';

/**
 * Hits the 'save-to-home' element route.
 */
export const saveCurrentBoardToHome = () => async (dispatch, getState) => {
    const state = getState();

    const currentUser = getCurrentUser(state);

    if (getIsGuestProp(currentUser)) return;

    const rootBoardId = getRootBoardId(currentUser);

    const breadcrumb = breadcrumbSelector(state);
    const rootSharedBoardId = propIn(['path', 0], breadcrumb) || getCurrentBoardIdFromState(state);

    const permissionId = getClosestPermissionIdForElementIdSelector()(state, { elementId: rootSharedBoardId });

    const location = {
        parentId: rootBoardId,
        section: BoardSections.INBOX,
        position: {
            index: 0,
        },
    };

    await dispatch(
        createAliasToElement({
            elementId: rootSharedBoardId,
            permissionId,
            location,
        }),
    );

    return dispatch(deselectAll({ userId: getUserId(currentUser) }));
};
